/* eslint-disable @angular-eslint/component-selector */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { LocationModel } from '@kanzi-apes/kanzi-models';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'kanzi-floormap-creator',
    templateUrl: './floormap-creator.component.html',
    styleUrls: ['./floormap-creator.component.scss'],
    standalone: false
})
export class FloormapCreatorComponent implements OnChanges {
  @Input() floorDataComplete: {
    dataGroup: { object: any; type: string }[];
    locationSelected: LocationModel | null;
  } | null = null;
  // @Input() dataGroup: { object: any; type: string }[] = [];
  @Output() saveLocationFloor = new EventEmitter<LocationModel>();
  @Output() saveLocationItemsFloor = new EventEmitter<any[]>();
  locationSelected: LocationModel | null = null;
  floorData?: { room_name: string };
  constructor(private confirmationService: ConfirmationService) {}


  ngOnChanges() {
    if (this.floorDataComplete) {
      this.locationSelected = this.floorDataComplete.locationSelected;
      // this.floorData = this.locationSelected.params
      //   ? this.locationSelected.params.data_floor
      //     ? this.locationSelected.params.data_floor
      //     : null
      //   : null;
    }
  }

  onSaveLocationsFloor(data: any[]) {
    this.saveLocationItemsFloor.emit(data);
  }

  onSaveExtrasFloor(data: any[]) {
    if (this.locationSelected) {
      if (
        this.locationSelected.params &&
        this.locationSelected.params.data_floor && 
        this.locationSelected.params.data_floor.room_extras
      ) {
        const roomExtrasClone: any[] = [].concat(
          this.locationSelected.params.data_floor.room_extras
        );
        data.forEach((dataExtra) => {
          let extrasSet: any[] = [];
          extrasSet = roomExtrasClone.filter(
            (extra) => extra.title === dataExtra.title
          );
          if (extrasSet.length === 0) {
            this.locationSelected?.params.data_floor.room_extras.push(
              dataExtra
            );
          } else {
            const newLocationSelected: LocationModel = {
              ...this.locationSelected,
              params: {
                ...this.locationSelected?.params,
                data_floor: {
                  ...this.locationSelected?.params['data_floor'],
                  room_extras:
                    this.locationSelected?.params.data_floor.room_extras.map(
                      (extra: any) => {
                        if (extra.title === dataExtra.title) {
                          return dataExtra;
                        } else {
                          return extra;
                        }
                      }
                    ),
                },
              },
            } as LocationModel;

            this.locationSelected = newLocationSelected;
          }
        });
        this.saveLocationFloor.emit(this.locationSelected);
      }else if( this.locationSelected.params &&  this.locationSelected.params.data_floor && this.locationSelected.params.data_floor.room_name){
        const newLocationSelected: LocationModel = {
          ...this.locationSelected,
          params: {
            data_floor: {
              ...this.locationSelected?.params['data_floor'],
              room_extras:data
            },
          },
        } as LocationModel;

        this.locationSelected = newLocationSelected;
        this.saveLocationFloor.emit(this.locationSelected);
      }else{
        this.confirmationService.confirm({
          message:
            'Debe agregar primero el room para hacer cualquier cambio',
          header: 'Información',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Aceptar',
          rejectVisible:false
        });
      }
    }
  }

  onDeleteExtrasFloor(data: any[]) {
    if (this.locationSelected) {
      if (
        this.locationSelected.params &&
        this.locationSelected.params.data_floor.room_extras
      ) {
        let newExtras = this.locationSelected.params.data_floor.room_extras;
        data.forEach((extra) => {
          newExtras = newExtras.filter(
            (item: any) => item.title !== extra.title
          );
        });
        // this.locationSelected.params.data_floor.room_extras = newExtras;
        const newLocationSelected: LocationModel = {
          ...this.locationSelected,
          params: {
            ...this.locationSelected?.params,
            data_floor: {
              ...this.locationSelected?.params['data_floor'],
              room_extras: newExtras,
            },
          },
        } as LocationModel;

        this.locationSelected = newLocationSelected;
        this.saveLocationFloor.emit(this.locationSelected);
      }
    }
  }

  onSelectedRoom(event: string) {
    if (this.locationSelected) {
      if (
        this.locationSelected.params &&
        this.locationSelected.params.data_floor?.room_name
      ) {
        this.confirmationService.confirm({
          message:
            'Ya existe un room cargado para esta locación, ¿desea actualizarlo?',
          header: 'Confirmar',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Actualizar',
          rejectLabel: 'Cancelar',
          accept: () => {
            this.updateRoom(event);
          },
        });
      } else {
        this.confirmationService.confirm({
          message: '¿Desea agregar el room a esta locación?',
          header: 'Confirmar',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Agregar',
          rejectLabel: 'Cancelar',
          accept: () => {
            this.updateRoom(event);
          },
        });
      }
    }
  }

  updateRoom(room: string) {
    const newLocationSelected: LocationModel = {
      ...this.locationSelected,
      params: {
        ...this.locationSelected?.params,
        data_floor: {
          ...this.locationSelected?.params['data_floor'],
          room_name: room,
        },
      },
    } as LocationModel;

    this.locationSelected = newLocationSelected;
    this.saveLocationFloor.emit(this.locationSelected);
  }
}
